import axios from 'axios';
import { logout } from '../utils/auth';
import { UNAUTHORIZED_ERROR } from '../utils/const';

const url = process.env.REACT_APP_API_ENDPOINT;

const service = axios.create({
  baseURL: url,
  timeout: 5000,
  headers: {
    common: {
      Authorization: localStorage.getItem('jwtToken') || undefined
    }
  }
});

/**
 * @param {import('history').History} history - from useHistory() hook
 * @param {import('t').Translation} translation - from useTranslations()
 */
export function setupInterceptor(history, t) {
  service.interceptors.response.use(response => {
    return response;
  }, error => {
    if (error.response?.status === 401) {
      logout();
      history.push('/');
      const errorMessage = error.response.data.error === UNAUTHORIZED_ERROR ?
        t(`login.alert.${UNAUTHORIZED_ERROR}`) : error.response.data.error;

      return Promise.reject({ message: errorMessage,status: error.response.status });
    }

    const errorMessage =
      error.response?.data?.error || error.message;

    return Promise.reject({ message: errorMessage, status: error.response?.status });
  });
};

export function setAuthorizationToken(token) {
  if (token) {
    service.defaults.headers.common.Authorization = `${token}`;
  } else {
    delete service.defaults.headers.common.Authorization;
  }
}

export default service;
